export interface SettingLink {
  label: string;
  description: string;
  path?: string;
  /** If provided, navigates via window.location.href instead of react-router */
  externalUrl?: () => string;
}

export const SETTINGS: SettingLink[] = [
  {
    label: 'Check-In Settings',
    description: 'Configure the Friday check-in feature for your team.',
    path: '/admin/checkin-settings',
  },
  {
    label: 'Profile Settings',
    description: 'Update your avatar, signature, and personal preferences.',
    path: '/profile',
  },
  {
    label: 'Reconnect RingCentral',
    description: 'Re-authorize the RingCentral OAuth integration for telephony.',
    externalUrl: () => {
      const backendHost =
        import.meta.env.VITE_APP_DJANGO_BACKEND_HOST || 'http://localhost:8000';
      const origin = encodeURIComponent(window.location.origin);
      const redirectTo = encodeURIComponent(window.location.href);
      return `${backendHost}/api/integrations/ringcentral/oauth/connect?origin=${origin}&redirect_to=${redirectTo}`;
    },
  },
];
